import * as types from '../actions/types.action';

const initialState = {
  uploading: false,
  uploadError: null,
  uploadResult: null,
  invoices: [],
  invoicesLoading: false,
  invoicesError: null,
  page: {page: 0, totalPages: 0, totalElements: 0},
  detail: null,
  detailLoading: false,
  detailError: null,
  // Anonymous (not-logged-in) upload allowance — see
  // anonymous-price-comparison-api.pdf. Null until GET /quota (or a 429 on
  // upload) has reported it.
  quota: null,
  quotaLoading: false,
  quotaError: null,
  // Server-side killswitch for the anonymous flow (empty-body 503).
  featureUnavailable: false,
};

export default function invoiceUploadReducer(state = initialState, action) {
  switch (action.type) {
    case types.UPLOAD_INVOICE_REQUESTED:
      return Object.assign({}, state, {
        uploading: true,
        uploadError: null,
        uploadResult: null,
      });
    case types.UPLOAD_INVOICE_SUCCESS:
      return Object.assign({}, state, {
        uploading: false,
        uploadResult: action.response,
      });
    case types.UPLOAD_INVOICE_FAILED:
      return Object.assign({}, state, {
        uploading: false,
        uploadError: action.error,
      });
    case types.UPLOAD_INVOICE_RESET:
      return Object.assign({}, state, {
        uploading: false,
        uploadError: null,
        uploadResult: null,
      });

    case types.FETCH_UPLOADED_INVOICES_REQUESTED:
      return Object.assign({}, state, {
        invoicesLoading: true,
        invoicesError: null,
      });
    case types.FETCH_UPLOADED_INVOICES_SUCCESS:
      return Object.assign({}, state, {
        invoicesLoading: false,
        invoices: action.data.invoices,
        page: {
          page: action.data.page,
          totalPages: action.data.totalPages,
          totalElements: action.data.totalElements,
        },
      });
    case types.FETCH_UPLOADED_INVOICES_FAILED:
      return Object.assign({}, state, {
        invoicesLoading: false,
        invoicesError: action.error,
      });

    case types.FETCH_UPLOADED_INVOICE_DETAIL_REQUESTED:
      // Silent (poll) refreshes keep the current detail on screen and don't show
      // the full-page spinner; only the initial load clears state.
      if (action.silent) {
        return state;
      }
      return Object.assign({}, state, {
        detailLoading: true,
        detailError: null,
        detail: null,
      });
    case types.FETCH_UPLOADED_INVOICE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        detailLoading: false,
        detail: action.data,
      });
    case types.FETCH_UPLOADED_INVOICE_DETAIL_FAILED:
      // A transient poll failure shouldn't wipe out the data already on screen.
      if (action.silent) {
        return state;
      }
      return Object.assign({}, state, {
        detailLoading: false,
        detailError: action.error,
      });

    case types.FETCH_ANONYMOUS_QUOTA_REQUESTED:
      return Object.assign({}, state, {
        quotaLoading: true,
        quotaError: null,
      });
    case types.FETCH_ANONYMOUS_QUOTA_SUCCESS:
      return Object.assign({}, state, {
        quotaLoading: false,
        quota: action.quota,
      });
    case types.FETCH_ANONYMOUS_QUOTA_FAILED:
      return Object.assign({}, state, {
        quotaLoading: false,
        quotaError: action.error,
      });
    case types.INVOICE_UPLOAD_FEATURE_UNAVAILABLE:
      return Object.assign({}, state, {
        uploading: false,
        quotaLoading: false,
        featureUnavailable: true,
      });

    case types.REMOVE_AUTH_SUCCESS:
      return initialState;

    default:
      return state;
  }
}
